"use client";
import { Box, Columns, Row, Text } from '@dxp-feed/ui';
import Link from 'next/link';
import React from 'react'
import parse from "html-react-parser";
import { handleRedirectOnMap } from '@/helpers/storeLocatorHelper';

const ContinuingCarePharmacy = ({store,handleContinuingCare}:any) => {
    const continuingCarePharmacyDeatils = store?.continuingCarePharmacy?.[0] || null
        const fixTimeFormat = (timeStr: string | null | undefined): string => {
        if (!timeStr || typeof timeStr !== "string") return "Closed";
        return timeStr.replace(/\b(\d{1,2}):(\d{2})\s*am\b/g, (match, hourStr, minute) => {
            let hour = parseInt(hourStr, 10);
            const correctedPeriod = hour >= 8 ? "pm" : "am";
            return `${hour}:${minute} ${correctedPeriod}`;
        });
        };

    return (
        <Box className="border-solid border-[1px] shadow-cardShadow mt-5 py-4 px-6 rounded-md">
            <div className="border-solid mb-4 flex justify-between items-center">
                <h3 className="text-xl font-sans text-brandSecondary">{continuingCarePharmacyDeatils?.pharmacyTitle}</h3>
                <button className="icon-close text-brandBlack cursor-pointer" aria-label="department close"onClick={handleContinuingCare}></button>
            </div>
            <Row className="md:gap-0 gap-6">
                <Columns className="col-3 lg:w-3/12 2md:w-1/2 w-full">
                    <Box as="div">
                        <Text as="p" className="text-base text-brandSecondary pb-4 font-bold">
                            {continuingCarePharmacyDeatils?.addressHeading}
                        </Text>
                        <Box as="div" className="flex gap-3 [&_.icon-forward-arrow:before]:text-sm [&_.icon-forward-arrow:before]:text-brandSecondary ">
                            <Text as="span" className="icon-house text-base text-brandPrimary">
                            </Text>
                            <Box as="div" className="">
                                <Text as="p" className="text-body font-normal">
                                    {parse(continuingCarePharmacyDeatils?.address || "")}
                                </Text>
                                <Link
                                    className="icon-forward-arrow text-body flex text-brandSecondary font-semibold flex-row-reverse justify-end gap-2 pt-2 items-center"
                                    href={store?._geoloc?.lat && store?._geoloc?.lng ? "#" : "javascript:void(0)"}
                                    onClick={() => {
                                        if (store?._geoloc?.lat && store?._geoloc?.lng) {
                                        handleRedirectOnMap(
                                            store._geoloc.lat,
                                            store._geoloc.lng,
                                            store?.address,
                                            store?.locationName
                                        );
                                        }
                                    }}
                                    >
                                    Get Directions
                                    </Link>
                            </Box>
                        </Box>

                        <Box as="div">
                            <Text as="p" className="text-base text-brandSecondary pb-2 pt-4  font-bold">
                                {continuingCarePharmacyDeatils?.managerHeading}
                            </Text>
                            <Box as="div" className="flex gap-3 items-center [&_.icon-forward-arrow:before]:text-sm [&_.icon-forward-arrow:before]:text-brandSecondary ">
                                <Text as="span" className="icon-user text-base text-brandPrimary">
                                </Text>
                                <Text as="p" className="text-body font-normal">
                                    {continuingCarePharmacyDeatils?.managerName}
                                </Text>
                            </Box>
                            <Box as="div" className="pt-2 flex gap-3 items-center [&_.icon-forward-arrow:before]:text-sm [&_.icon-forward-arrow:before]:text-brandSecondary ">
                                <Text as="span" className="icon-contract text-base text-brandPrimary">
                                </Text>
                                <Text as="p" className="text-body font-normal">
                                    <a className="text-body font-normal"
                                       href={process.env.NEXT_PUBLIC_AEM_PATH_URL + continuingCarePharmacyDeatils?.directionsUrl}>
                                       {continuingCarePharmacyDeatils?.licenseNumber}
                                     </a>
                                </Text>
                            </Box>
                        </Box>

                        <Box as="div">
                            <Text as="p" className="text-base text-brandSecondary pb-2 pt-4  font-bold">
                                {continuingCarePharmacyDeatils?.contactHeading}
                            </Text>
                            <Box as="div" className="flex gap-3 items-center [&_.icon-phone:before]:text-base [&_.icon-forward-arrow:before]:text-brandSecondary ">
                                <Text as="span" className="icon-phone h-4 text-base text-brandPrimary">
                                </Text>
                                <Link className='text-body flex flex-row-reverse justify-end gap-2 pt-2 items-center' href={`tel:${continuingCarePharmacyDeatils?.primaryPhone}`}>{continuingCarePharmacyDeatils?.primaryPhone}
                                </Link>
                            </Box>
                            <Box as="div" className="pt-2 flex gap-3 items-center [&_.icon-contract:before]:text-base [&_.icon-forward-arrow:before]:text-brandSecondary ">
                                <Text as="span" className="icon-contract h-4 text-base text-brandPrimary">
                                </Text>
                                <Link className='text-body flex text-brandSecondary flex-row-reverse justify-end gap-2 pt-2 items-center' href={`fax:${continuingCarePharmacyDeatils?.faxNumber}`}>{continuingCarePharmacyDeatils?.faxNumber}
                                </Link>
                            </Box>
                            <Box as="div" className=" pt-2 flex gap-3 items-center [&_.icon-envelope:before]:text-[13px] [&_.icon-forward-arrow:before]:text-brandSecondary ">
                                <Text as="span" className="icon-envelope h-4 w-4 text-base text-brandPrimary">
                                </Text>
                                <Link className='text-body flex text-brandSecondary flex-row-reverse justify-end gap-2 pt-2 items-center' href={`mailto:${continuingCarePharmacyDeatils?.emailAddress}`}>{continuingCarePharmacyDeatils?.emailAddress}
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Columns>

                <Columns className="col-3 lg:w-3/12 2md:w-1/2 w-full">
                    <Box as="div">
                        <Text
                            as="p"
                            className="text-base text-brandSecondary font-bold">
                            {continuingCarePharmacyDeatils?.proprietorHeading}
                        </Text>
                        <Box as="div" className=" pt-4">
                            <Text as="p" className="text-body font-normal">
                                {parse(continuingCarePharmacyDeatils?.address1 || "")}
                            </Text>
                                <Text as="p" className="text-body font-normal">
                                {parse(continuingCarePharmacyDeatils?.tel || "")}
                            </Text>
                        </Box>
                        <Box as="div" className="pt-6">
                            <Text as="p" className="text-body font-normal flex flex-col">
                                <Text as="span" className="text-body font-semibold pb-4">{continuingCarePharmacyDeatils?.pleaseNote}</Text>
                                {parse(continuingCarePharmacyDeatils?.pleaseNoteText || "")}
                            </Text>
                        </Box>

                    </Box>
                </Columns>
                <Columns className="col-3 lg:pt-0 2md:pt-6 lg:w-3/12 2md:w-1/2 w-full">
                    <Box as="div" className="">
                        <Text as="p" className="text-base text-brandSecondary font-bold">
                            {continuingCarePharmacyDeatils?.statement}
                        </Text>
                        <Box as="div" className="pt-4">
                            <Text as="p" className="text-body font-normal">
                                {parse(continuingCarePharmacyDeatils?.legalStatement || "")}
                            </Text>
                        </Box>
                        <Text as="p" className="text-base pt-4 text-brandSecondary font-bold">
                            {continuingCarePharmacyDeatils?.patientConcerns}
                        </Text>
                        <Box as="div" className="">
                            <Text as="p" className="text-body font-normal pt-4">
                                {parse(continuingCarePharmacyDeatils?.patientConcernsText || "")}
                            </Text>
                        </Box>
                        <Box as="div" className="pt-6">
                            <Text as="p" className="text-body font-normal flex flex-col">
                                <Text as="span" className="text-body font-semibold pb-4">{continuingCarePharmacyDeatils?.pleaseNote}</Text>
                                {continuingCarePharmacyDeatils?.pleaseNoteText}
                            </Text>
                        </Box>
                    </Box>
                </Columns>

                <Columns className="col-3 lg:pt-0 2md:pt-6 lg:w-3/12 2md:w-1/2 w-full">
                    <Box>
                        <Text className="text-base text-brandSecondary font-bold">
                            Hours of operation
                        </Text>
                        <Box className="flex flex-wrap pt-4">
                            <Text className="text-body w-1/2 font-normal capitalize">Day</Text>
                            <Text className="text-body w-1/2">Hours</Text>
                        </Box>

                        {["monday", "tuesday", "wednesday", "thursday", "friday"].map(day => (
                            <Box key={day} className="flex flex-wrap pt-4 justify-between">
                            <Text className="text-body w-1/2 font-normal capitalize">
                                {day.charAt(0).toUpperCase() + day.slice(1)}
                            </Text>
                            <Text className="text-body w-1/2">
                                {fixTimeFormat(continuingCarePharmacyDeatils?.hours?.[day])}
                            </Text>
                            </Box>
                        ))}

                        <Box className="flex flex-wrap pt-4 justify-between">
                            <Text className="text-body w-1/2 font-normal capitalize">Saturday</Text>
                            <Text className="text-body w-1/2">
                            {fixTimeFormat(continuingCarePharmacyDeatils?.hours?.saturday)}
                            </Text>
                        </Box>

                        <Box className="flex flex-wrap gap-6 pt-4">
                            <Text className="text-body font-normal capitalize">
                            Sunday / Holidays {continuingCarePharmacyDeatils?.hours?.sunday === "" ? "Closed" : fixTimeFormat(continuingCarePharmacyDeatils?.hours?.sunday)}
                            </Text>
                        </Box>
                    </Box>
                </Columns>
            </Row>

        </Box>
    )
}

export default ContinuingCarePharmacy
